const mapFailuresToAlertLabels = (failures, errorLabelMap, fallbackLabelKey) => {
  return failures.reduce((acc, failure) => {
    if (failure.__typename && errorLabelMap[failure.__typename]) {
      const alert = errorLabelMap[failure.__typename];
      if (alert) {
        acc.push(alert);
      }
    } else {
      acc.push({ type: "error", title: failure.message || fallbackLabelKey });
    }
    return acc;
  }, []);
};
export {
  mapFailuresToAlertLabels
};
//# sourceMappingURL=map-failures-to-alert-labels.js.map
